import { MapContainer, TileLayer } from 'react-leaflet'
import { Card, CardBody, Col } from 'reactstrap'
import { H2, H5, LI, UL } from '../../../../AbstractElements'
import { monthlyDropdownList, saleTopCountriesData } from '../../../../Data/DashboardsData/ECommerceData'
import { worldMapProps } from '../../../../Data/MiscellaneousData/MapsData'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { SaleTopCountriesTitle } from '../../../../Utils/Constants'

export default function SaleTopCountries() {
    return (
        <Col xxl={3} xl={4} sm={6} className="box-col-4">
            <Card className="state">
                <DropdownWithHeader headerClass='pb-0' heading={SaleTopCountriesTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody>
                    {saleTopCountriesData.map((item) => (
                        <UL key={item.id} className={`d-flex simple-list flex-row ${item.id === 2 ? 'mt-4' : ''}`}>
                            {item.data.map((data) => (
                                <LI className="balance-card" key={data.id}>
                                    <div className="Countries">
                                        <span className="rounded-pill" />
                                        <H5>{data.country}</H5>
                                    </div>
                                    <H2 className="mt-1 mb-0">{data.value}%</H2>
                                </LI>
                            ))}
                        </UL>
                    ))}
                    <MapContainer
                        className="jvector-map-height custom-map"
                        {...worldMapProps}>
                        <TileLayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
                    </MapContainer>
                </CardBody>
            </Card>
        </Col>
    )
}